/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Subscriber/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Subscriber({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AssignedInsurance/Content/AssignedInsuranceItem/Subscriber"
  
}) {
let assignedInsuranceInsuranceSubscriptionPersonFirstNameValueData = fromData.useDataValue({ viewPath,
context: 'assigned_insurance',
path: 'insurance_subscription.person.first_name',
})
let assignedInsuranceInsuranceSubscriptionPersonLastNameValueData = fromData.useDataValue({ viewPath,
context: 'assigned_insurance',
path: 'insurance_subscription.person.last_name',
})
let aggregateData = fromAggregate.join(assignedInsuranceInsuranceSubscriptionPersonFirstNameValueData, assignedInsuranceInsuranceSubscriptionPersonLastNameValueData)
  return (<React.Fragment
>
<div
  data-testid="Subscriber.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="assigned_insurance.insurance_subscription.person.first_name"
 data="assigned_insurance.insurance_subscription.person.last_name"
 aggregate="/Data/aggregate.js join"
 text={aggregateData}
/>
</div>
{children}
</React.Fragment>)
}